import React from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Autoplay, Navigation} from 'swiper/modules';
import servicesData from '../../../data/services-data';
import image from "../../../assets/img/page/services.jpg";

const ServicesFour = () => {
    const slideControl = {
        spaceBetween: 25,
        slidesPerView: 3,
        speed: 1000,
        loop: true,
        autoplay: {
            delay: 4000,
            reverseDirection: false,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 1,
            },
            768: {
                slidesPerView: 2,
            },
            1025: {
                slidesPerView: 3,
            },
        },
    };
    return (
        <div className="services__four">
        </div>
    );
};

export default ServicesFour;